/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Create_BtnInputs */



/**
* | output |
* | --- |
* | "Create User" |
*
* @param {User_Create_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_create_btn = /** @type {((inputs?: User_Create_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Create_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer l'utilisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear usuario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criar Usuário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea Utente")
	return /** @type {LocalizedString} */ ("Create User")
});